export function formatDollars(val) {
    var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });

    return formatter.format(val);
}

export function formatDollarsNoZeros(val) {
    var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });
    return formatter.format(val).split(".")[0];
}


export function formatDollarsNoZerosShaded(val) {
    return  formatDollarsNoZeros(val).replace(/[0-9]/g, 'X')
}

export function formatMillionsDollars(val) {
    return '$' + (val / 1000000) + 'M';
}
